import { render, staticRenderFns } from "./HotelDetailsBundleV2.vue?vue&type=template&id=4ff33b2e&"
import script from "./HotelDetailsBundleV2.vue?vue&type=script&lang=js&"
export * from "./HotelDetailsBundleV2.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetailsBundleV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports